import {
  useInnerBlocksProps,
  useBlockProps,
  BlockControls,
} from '@wordpress/block-editor';
import { Button, ToolbarGroup } from '@wordpress/components';
import { useEffect } from '@wordpress/element';
import { Icon } from '@components/ui/Icon';
import interaction from '@tailwind/interaction';
import { template } from 'lodash';

import EyeOpenIcon from 'blockbite-icons/dist/EyeOpen';
import EyeClosedIcon from 'blockbite-icons/dist/EyeClosed';

export default function Edit({ attributes, setAttributes, clientId }) {
  const { biteMeta } = attributes;
  const currentActionType = biteMeta?.interaction?.actionType || '';
  const currentActionRef = biteMeta?.interaction?.actionRef || '';
  const currentActionPreview = biteMeta?.interaction?.actionPreview || '';

  const blockProps = useBlockProps({
    className: `bf_relative bf_overflow-hidden ${currentActionPreview ? 'b_active' : ''}`,
  });

  const toggleActionPreview = (toggle) => {
    setAttributes({
      biteMeta: {
        ...biteMeta,
        interaction: {
          ...biteMeta.interaction,
          actionPreview: toggle,
        },
      },
    });
  };

  const TEMPLATE = [
    [
      'blockbite/group',
      {
        metadata: {
          name: 'Block A',
        },
      },
    ],
    [
      'blockbite/group',
      {
        metadata: {
          name: 'Block B',
        },
        biteStyle: [
          {
            id: 'tile_in',
            value: 'b_tile-in-left',
            screen: 'all',
          },
        ],
        biteClass: 'b_tile-in-left',
      },
    ],
  ];

  const { children, ...innerBlocksProps } = useInnerBlocksProps(
    {},
    {
      template: TEMPLATE,
      allowedBlocks: ['blockbite/group'],
    }
  );

  return (
    <div {...blockProps}>
      <BlockControls>
        <ToolbarGroup>
          <Button
            isPressed={currentActionPreview}
            onClick={() => {
              if (currentActionPreview) {
                toggleActionPreview(false);
              } else {
                toggleActionPreview(true);
              }
            }}
          >
            <Icon
              className="h-5 w-5"
              icon={currentActionPreview ? EyeOpenIcon : EyeClosedIcon}
            />
          </Button>
        </ToolbarGroup>
      </BlockControls>

      <div {...innerBlocksProps}>{children}</div>
    </div>
  );
}
